import { InitialValues } from 'forms/types';

import { BasicsFormValues } from '../form/types';
import { GetBasicsQuery } from '../graphql/GetSurveyBasics';

const buildInitialValues = (data?: GetBasicsQuery): InitialValues<BasicsFormValues> => {
  const surveyBasics = data?.surveyBasics;

  return {
    dateOfBirth: surveyBasics?.dateOfBirth,
    gender: surveyBasics?.gender,
    stateId: surveyBasics?.stateId,
  };
};

export default buildInitialValues;
